/**
 * @services/analytics — stable import path, now backed by the in-house Wisetap
 * ingest module (src/services/analytics/). Kept as a thin re-export so all
 * ~60 call sites stay unchanged.
 *
 * Public API is identical to the previous CleverTap singleton (setUser /
 * trackScreen / trackFbGoogleEvents / trackEvent / trackEventCT), plus flush()
 * and reset(). The CleverTap SDK is fully removed — Wisetap is the only
 * event/profile sink. Push notifications are plain FCM, rendered natively
 * (CustomFcmMessageListenerService) with channels created in MainApplication.
 *
 * NOTE: the target is "./analytics/index" (the directory), NOT "./analytics"
 * which would resolve back to this file (file-over-directory) and self-loop.
 */
export { default } from "./analytics/index";
